/* saulemofficial catalog interactions, adapted to run inside the saulemofficial page shell. */
(function () {
  'use strict';
  var zone = document.querySelector('#li-merge-products');
  if (!zone) return;
  var locale = (new URLSearchParams(location.search).get('lang') || (document.documentElement.dataset && document.documentElement.dataset.saulemLocale) || (window.Shopify && Shopify.locale) || 'en').toLowerCase();
  var ZH = locale === 'zh';
  var T = ZH ? {
    all:'全部可见产品', products:'个产品', showing:'显示', of:'共', sort:'排序',
    selected:'个产品已选择进行比较', clear:'清除', compare:'比较产品',
    limit:'最多可比较 3 个产品。', quick:'快速查看', ready:'Ready for inquiry',
    verified:'已核验', format:'规格', moq:'MOQ', lead:'LEAD TIME', packaging:'PACKAGING',
    scent:'香型', oem:'OEM', media:'图片', available:'可提供',
    indicative:'Indicative terms', details:'查看完整详情', add:'加入询盘',
    close:'关闭', review:'并排比较', reviewCopy:'并排查看规格和参考商业条款，不虚构价格。',
    attribute:'参数', remove:'移除', continue:'继续浏览', clearCompare:'清除比较',
    filters:'筛选', apply:'应用筛选', noResults:'没有匹配的产品，请调整筛选条件。',
    active:'当前筛选', any:'全部'
  } : {
    all:'All visible products', products:'products', showing:'Showing', of:'of', sort:'Sort',
    selected:'selected to compare', clear:'Clear', compare:'Compare products',
    limit:'You can compare up to 3 products.', quick:'Quick view', ready:'Ready to inquire',
    verified:'Verified', format:'Format', moq:'MOQ', lead:'Lead time', packaging:'Packaging',
    scent:'Scent', oem:'OEM', media:'Media', available:'Available',
    indicative:'Indicative terms', details:'View full details', add:'Add to Inquiry',
    close:'Close', review:'Side-by-side review', reviewCopy:'Compare formats and indicative commercial terms without invented pricing.',
    attribute:'Attribute', remove:'Remove', continue:'Continue browsing', clearCompare:'Clear comparison',
    filters:'Filters', apply:'Apply filters', noResults:'No matching products. Try adjusting filters.',
    active:'Active filters', any:'All'
  };
  var ICON = {
    x:'<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>',
    scale:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"/></svg>',
    plus:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="M12 5v14"/></svg>'
  };
  var cards = [].slice.call(zone.querySelectorAll('.v2-catalog-product-card'));
  var grid = zone.querySelector('.v2-catalog-product-grid');
  var search = zone.querySelector('.v2-catalog-search input[type=search]');
  var sort = zone.querySelector('.v2-sort-control select');
  var filterRail = zone.querySelector('.v2-catalog-filter-rail');
  var filterInputs = [].slice.call(zone.querySelectorAll('.v2-catalog-filters input[type=checkbox]'));
  var moqSelect = zone.querySelector('.v2-catalog-filters select');
  var resultCount = zone.querySelector('.v2-result-count');
  var resultHeading = zone.querySelector('.v2-catalog-result-heading > p');
  var filterStatus = zone.querySelector('.v2-no-active-filters');
  var compareLimit = zone.querySelector('.v2-compare-limit');
  var viewButtons = [].slice.call(zone.querySelectorAll('.v2-view-switch button'));
  // Keep catalog cards synchronized with Shopify product records.
  cards.forEach(function(card){ var link=card.querySelector('.v2-product-heading h3 a'); if(!link) return; fetch(link.getAttribute('href')+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){ if(!p) return; var title=p.title||''; link.textContent=title; var media=card.querySelector('.v2-product-media img'); if(media&&p.featured_image) media.src=p.featured_image; var benefit=card.querySelector('.v2-product-benefit'); if(benefit&&p.description){var desc=p.description.replace(/<[^>]*>/g,'').replace(/\s+/g,' ').trim(); benefit.textContent=desc.length>190?desc.slice(0,187).replace(/\s+$/,'')+'...':desc;} var action=card.querySelector('.v2-product-action'); if(action) action.setAttribute('aria-label','Add to Inquiry '+title); var meta=((p.product_type||p.type||'')+' '+(p.tags||'')).toLowerCase(); var cat=meta.indexOf('fruit')!==-1?'fruit':meta.indexOf('craft')!==-1?'craft':'fragrance'; card.setAttribute('data-cat',cat); var cached=products&&products.find(function(x){return x.card===card;}); if(cached) cached.family=cat==='fruit'?'fruit-soap':cat==='craft'?'craft-soap':'fragrance-soap'; setTimeout(apply,0); }); });
  var selected = [];
  var portal;

  function esc(value) {
    return String(value || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');
  }
  function slug(value) {
    return String(value || '').toLowerCase().replace(/\s+/g,'-').replace(/[^a-z-]/g,'');
  }
  function number(value) {
    var match = String(value || '').replace(/,/g,'').match(/\d+/);
    return match ? parseInt(match[0],10) : 0;
  }
  function cardMeta(card, index) {
    var taxonomy = [].slice.call(card.querySelectorAll('.v2-product-taxonomy span')).map(function (x) { return x.textContent.trim(); });
    var terms = [].slice.call(card.querySelectorAll('.v2-product-terms dd'));
    var rawFamily = card.getAttribute('data-cat') || 'fragrance';
    var family = rawFamily === 'fruit' ? 'fruit-soap' : rawFamily === 'craft' ? 'craft-soap' : 'fragrance-soap';
    var scentText = (taxonomy[0] || '').toLowerCase();
    var scent = ['floral','fresh','milky','woody','unscented'].filter(function (x) { return scentText.indexOf(x) !== -1; })[0] || '';
    var productLink = card.querySelector('.v2-product-media, .v2-product-heading a');
    var href = productLink && productLink.getAttribute('href') || '/products/dark-vanilla-fragrance-soap';
    return {
      card:card, index:index,
      name:(card.querySelector('h3') || {}).textContent.trim(),
      image:(card.querySelector('.v2-product-media img') || {}).getAttribute('src') || '',
      format:(card.querySelector('.v2-product-heading p') || {}).textContent.trim(),
      benefit:(card.querySelector('.v2-product-benefit') || {}).textContent.trim(),
      family:family, category:'bar-soap', scent:scent,
      status:card.querySelector('.v2-product-status-coming-soon') ? 'coming-soon' : 'active',
      availability:card.querySelector('.v2-product-status-coming-soon') ? ['coming-soon'] : ['active','oem'],
      moq:number(terms[0] && terms[0].textContent), lead:number(terms[1] && terms[1].textContent),
      packaging:ZH ? '独立膜包 / 礼盒纸盒 / 箱规：380 x 250 x 300 mm；72 个/箱。' : 'Individually wrapped / gift-ready paper box / Carton: 380 x 250 x 300 mm; 72 pcs/carton.',
      href:href,
      compare:card.querySelector('.v2-catalog-card-tools input[type=checkbox]')
    };
  }
  var products = cards.map(cardMeta);
  products.forEach(function (p) {
    [].slice.call(p.card.querySelectorAll('.v2-product-media, .v2-product-heading a, .v2-product-arrow')).forEach(function (a) {
      a.setAttribute('href', p.href);
    });
  });

  function groupFor(input) {
    var id = input.id || '';
    return ['category','family','availability','scent'].filter(function (g) { return id.indexOf('-' + g + '-') !== -1; })[0] || '';
  }
  function keyFor(input, group) {
    return (input.id || '').split('-' + group + '-').pop();
  }
  function activeFilters() {
    var groups = {};
    filterInputs.forEach(function (input) {
      if (!input.checked) return;
      var group = groupFor(input);
      (groups[group] || (groups[group] = [])).push(keyFor(input, group));
    });
    return groups;
  }
  function matches(p, groups, q, maxMoq) {
    if (q && (p.name + ' ' + p.benefit + ' ' + p.family + ' ' + p.scent).toLowerCase().indexOf(q) === -1) return false;
    if (maxMoq && p.moq > maxMoq) return false;
    return Object.keys(groups).every(function (group) {
      var value = group === 'availability' ? p.availability : [p[group]];
      return groups[group].some(function (key) { return value.indexOf(key) !== -1; });
    });
  }
  function renderFilterStatus(groups, q, maxMoq) {
    var labels = filterInputs.filter(function (i) { return i.checked; }).map(function (i) {
      return (i.closest('label').querySelector('span') || {}).textContent.trim();
    });
    if (q) labels.push((ZH ? '搜索: ' : 'Search: ') + q);
    if (maxMoq) labels.push('MOQ ≤ ' + maxMoq);
    filterStatus.className = labels.length ? 'v2-active-filters' : 'v2-no-active-filters';
    filterStatus.textContent = labels.length ? T.active + ': ' + labels.join(' · ') : T.all;
  }
  function apply() {
    var groups = activeFilters();
    var q = search ? search.value.trim().toLowerCase() : '';
    var maxMoq = moqSelect ? number(moqSelect.value) : 0;
    var visible = products.filter(function (p) {
      var show = matches(p, groups, q, maxMoq);
      p.card.hidden = !show;
      p.card.style.display = show ? '' : 'none';
      return show;
    });
    if (resultCount) resultCount.innerHTML = '<strong>' + visible.length + '</strong> ' + T.products;
    if (resultHeading) resultHeading.innerHTML = T.showing + ' <strong>' + visible.length + '</strong> ' + T.of + ' ' + products.length;
    renderFilterStatus(groups, q, maxMoq);
    var empty = zone.querySelector('.v2-catalog-empty');
    if (!visible.length && !empty) {
      empty = document.createElement('div');
      empty.className = 'v2-catalog-empty';
      empty.innerHTML = '<h2>' + T.noResults + '</h2>';
      grid.after(empty);
    }
    if (empty) empty.hidden = !!visible.length;
    grid.hidden = !visible.length;
  }
  function clearFilters() {
    filterInputs.forEach(function (i) { i.checked = false; });
    if (moqSelect) moqSelect.value = '';
    if (search) search.value = '';
    apply();
  }
  filterInputs.forEach(function (i) { i.addEventListener('change', apply); });
  if (moqSelect) moqSelect.addEventListener('change', apply);
  if (search) {
    search.addEventListener('input', apply);
    search.closest('form').addEventListener('submit', function (e) { e.preventDefault(); });
  }
  var clearButton = zone.querySelector('.v2-filter-heading .v2-text-button');
  if (clearButton) clearButton.addEventListener('click', clearFilters);

  if (sort) sort.addEventListener('change', function () {
    var list = products.slice();
    if (sort.value === 'newest') list.reverse();
    if (sort.value === 'moq-asc') list.sort(function (a,b) { return a.moq - b.moq || a.index - b.index; });
    if (sort.value === 'lead-time-asc') list.sort(function (a,b) { return a.lead - b.lead || a.index - b.index; });
    list.forEach(function (p) { grid.appendChild(p.card); });
  });
  viewButtons.forEach(function (button, index) {
    button.addEventListener('click', function () {
      viewButtons.forEach(function (b, i) { b.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
      grid.classList.toggle('v2-catalog-product-grid-grid', index === 0);
      grid.classList.toggle('v2-catalog-product-grid-list', index === 1);
      products.forEach(function (p) { p.card.classList.toggle('v2-catalog-product-list', index === 1); });
    });
  });

  function ensurePortal() {
    if (portal) return portal;
    portal = document.createElement('div');
    /* The saulemofficial header has its own extremely high stacking layer. Mounting
       dialogs at document level keeps the original saulemofficial overlay above it. */
    portal.className = 'li-merge-zone li-merge-catalog-portal';
    document.body.appendChild(portal);
    return portal;
  }
  function closeDialog() {
    if (portal) portal.innerHTML = '';
    document.documentElement.style.overflow = '';
  }
  function showDialog(html, dialogClass) {
    var root = ensurePortal();
    root.innerHTML = '<div class="janm-v2 v2-catalog-portal"><div class="v2-catalog-overlay" style="z-index:2147483646"></div>' + html + '</div>';
    document.documentElement.style.overflow = 'hidden';
    root.querySelector('.v2-catalog-overlay').addEventListener('mousedown', closeDialog);
    root.querySelectorAll('[data-catalog-close]').forEach(function (b) { b.addEventListener('mousedown', closeDialog); });
    var dialog = root.querySelector('.' + dialogClass);
    if (dialog) dialog.focus();
    return dialog;
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDialog(); });

  function quickView(p) {
    var dialogId = 'catalog-quick-' + p.index;
    var html = '<div role="dialog" id="' + dialogId + '" aria-describedby="' + dialogId + '-description" aria-labelledby="' + dialogId + '-title" aria-modal="true" data-state="open" class="v2-quick-view-dialog" tabindex="-1" style="pointer-events: auto;">' +
      '<button class="v2-icon-button v2-dialog-close" type="button" data-catalog-close aria-label="' + T.close + '">' + ICON.x + '</button>' +
      '<div class="v2-quick-view-media"><picture style="display: contents;"><img alt="' + esc(p.name) + '" loading="lazy" src="' + esc(p.image) + '"></picture><span class="v2-media-label v2-media-label-verified">' + T.verified + '</span></div>' +
      '<div class="v2-quick-view-copy"><p class="v2-eyebrow">' + T.ready + '</p><h2 id="' + dialogId + '-title">' + esc(p.name) + '</h2><p id="' + dialogId + '-description">' + esc(p.benefit) + '</p>' +
      '<div class="v2-quick-badges"><span>' + esc(p.format.split('/')[0]) + '</span><span>' + esc(p.family.replace(/-/g,' ')) + '</span><span>MOQ ' + p.moq + (ZH ? ' 件' : ' units') + '</span></div>' +
      '<dl class="v2-quick-terms"><div><dt>' + T.format + '</dt><dd>' + esc(p.format) + '</dd></div><div><dt>' + T.moq + '</dt><dd>' + p.moq + (ZH ? ' 件' : ' units') + '</dd></div>' +
      '<div><dt>' + T.lead + '</dt><dd>' + (ZH ? '1-7 天' : '1-7 days') + '</dd></div><div><dt>' + T.packaging + '</dt><dd>' + esc(p.packaging) + '</dd></div></dl>' +
      '<p class="v2-quick-terms-note">' + T.indicative + '</p><div class="v2-quick-actions">' +
      '<button class="v2-button v2-button-primary" type="button" data-quick-add>' + ICON.plus + T.add + '</button>' +
      '<a class="v2-button v2-button-quiet" href="' + p.href + '">' + T.details + '</a></div></div></div>';
    var dialog = showDialog(html, 'v2-quick-view-dialog');
    dialog.querySelector('[data-quick-add]').addEventListener('click', function () {
      p.card.querySelector('.v2-product-action').click();
      closeDialog();
    });
  }
  products.forEach(function (p) {
    var quick = p.card.querySelector('.v2-catalog-card-tools button');
    if (quick) quick.addEventListener('click', function () { quickView(p); });
  });

  function syncCompare() {
    products.forEach(function (p) { if (p.compare) p.compare.checked = selected.indexOf(p) !== -1; });
    var old = zone.querySelector('.v2-compare-tray');
    if (old) old.remove();
    if (!selected.length) return;
    var tray = document.createElement('div');
    tray.className = 'v2-compare-tray';
    tray.setAttribute('aria-label', T.selected);
    tray.innerHTML = ICON.scale + '<p><strong>' + selected.length + '</strong><span>' + T.selected + '</span></p>' +
      '<button class="v2-text-button" type="button" data-clear-compare>' + T.clear + '</button>' +
      '<button class="v2-button v2-button-primary" type="button" data-open-compare>' + T.compare + '</button>';
    grid.after(tray);
    tray.querySelector('[data-clear-compare]').addEventListener('click', function () { selected = []; syncCompare(); });
    tray.querySelector('[data-open-compare]').addEventListener('click', compareDialog);
    updateMobileBar();
  }
  products.forEach(function (p) {
    if (!p.compare) return;
    p.compare.addEventListener('change', function () {
      if (p.compare.checked && selected.length >= 3) {
        p.compare.checked = false;
        if (compareLimit) compareLimit.textContent = T.limit;
        return;
      }
      if (compareLimit) compareLimit.textContent = '';
      selected = p.compare.checked ? selected.concat(p) : selected.filter(function (x) { return x !== p; });
      syncCompare();
    });
  });
  function compareDialog() {
    if (!selected.length) return;
    var heads = selected.map(function (p) {
      return '<th scope="col"><picture style="display: contents;"><img alt="" loading="lazy" src="' + esc(p.image) + '"></picture><span>' + esc(p.name) + '</span><button type="button" aria-label="' + T.remove + ' ' + esc(p.name) + '" data-remove-compare="' + p.index + '">' + ICON.x + T.remove + '</button></th>';
    }).join('');
    function row(label, getter) { return '<tr><th scope="row">' + label + '</th>' + selected.map(function (p) { return '<td>' + esc(getter(p)) + '</td>'; }).join('') + '</tr>'; }
    var compareId = 'catalog-compare-dialog';
    var caption = (ZH ? '产品比较 ' : 'Comparison of products ') + selected.length + (ZH ? ' 个产品' : ' products to compare');
    var html = '<div role="dialog" id="' + compareId + '" aria-describedby="' + compareId + '-description" aria-labelledby="' + compareId + '-title" aria-modal="true" data-state="open" class="v2-compare-dialog" tabindex="-1" style="pointer-events: auto;"><div class="v2-compare-head"><div><p class="v2-eyebrow">' + T.review + '</p><h2 id="' + compareId + '-title">' + T.compare + '</h2><p id="' + compareId + '-description">' + T.reviewCopy + '</p></div>' +
      '<button class="v2-icon-button" type="button" data-catalog-close aria-label="' + T.close + '">' + ICON.x + '</button></div><div class="v2-compare-scroll"><table><caption class="v2-sr-only">' + caption + '</caption><thead><tr><th scope="col">' + T.attribute + '</th>' + heads + '</tr></thead><tbody>' +
      row('Status',function(){return T.ready;}) + row(T.format,function(p){return p.format;}) + row(T.moq,function(p){return p.moq + (ZH ? ' 件' : ' units');}) +
      row(T.lead,function(p){return ZH ? '1-7 天' : '1-7 days';}) + row(T.packaging,function(p){return p.packaging;}) +
      row(T.scent,function(p){return p.scent ? p.scent.charAt(0).toUpperCase() + p.scent.slice(1) : T.any;}) + row(T.oem,function(){return T.available;}) + row(T.media,function(){return T.verified;}) +
      '</tbody></table></div><div class="v2-compare-actions"><button class="v2-text-button" type="button" data-clear-dialog>' + T.clearCompare + '</button>' +
      '<button class="v2-button v2-button-primary" type="button" data-catalog-close>' + T.continue + '</button></div></div>';
    var dialog = showDialog(html, 'v2-compare-dialog');
    dialog.querySelectorAll('[data-remove-compare]').forEach(function (button) {
      button.addEventListener('click', function () {
        var index = parseInt(button.getAttribute('data-remove-compare'),10);
        selected = selected.filter(function (p) { return p.index !== index; });
        closeDialog(); syncCompare(); if (selected.length) compareDialog();
      });
    });
    dialog.querySelector('[data-clear-dialog]').addEventListener('click', function () { selected=[]; closeDialog(); syncCompare(); });
  }

  function openMobileFilters() {
    var clone = filterRail.querySelector('.v2-catalog-filters').cloneNode(true);
    clone.querySelectorAll('[id]').forEach(function (el) {
      var oldId = el.id;
      var newId = 'mobile-' + oldId;
      el.id = newId;
      var label = clone.querySelector('label[for="' + oldId + '"]');
      if (label) label.setAttribute('for', newId);
    });
    var html = '<aside role="dialog" aria-modal="true" class="v2-mobile-filter-drawer" tabindex="-1"><div class="v2-mobile-filter-head"><h2>' + T.filters + '</h2><button class="v2-icon-button" data-catalog-close aria-label="' + T.close + '">' + ICON.x + '</button></div><div class="v2-mobile-filter-body"></div><div class="v2-mobile-filter-actions"><button class="v2-button v2-button-primary" data-apply-mobile>' + T.apply + '</button></div></aside>';
    var drawer = showDialog(html, 'v2-mobile-filter-drawer');
    drawer.querySelector('.v2-mobile-filter-body').appendChild(clone);
    var clonedChecks = [].slice.call(clone.querySelectorAll('input[type=checkbox]'));
    clonedChecks.forEach(function (input, i) { input.checked = filterInputs[i].checked; });
    var clonedMoq = clone.querySelector('select'); if (clonedMoq && moqSelect) clonedMoq.value = moqSelect.value;
    drawer.querySelector('[data-apply-mobile]').addEventListener('click', function () {
      clonedChecks.forEach(function (input, i) { filterInputs[i].checked = input.checked; });
      if (clonedMoq && moqSelect) moqSelect.value = clonedMoq.value;
      closeDialog(); apply();
    });
    var cloneClear = clone.querySelector('.v2-filter-heading .v2-text-button');
    if (cloneClear) cloneClear.addEventListener('click', function () { clonedChecks.forEach(function(i){i.checked=false;}); if(clonedMoq)clonedMoq.value=''; });
  }
  [].slice.call(zone.querySelectorAll('.v2-mobile-filter-trigger')).forEach(function (b) { b.addEventListener('click', openMobileFilters); });
  var mobileBar = zone.querySelector('.v2-catalog-mobile-bar');
  function updateMobileBar() {
    if (!mobileBar) return;
    var buttons = mobileBar.querySelectorAll('button');
    if (buttons[1]) { buttons[1].disabled = !selected.length; buttons[1].onclick = compareDialog; }
    if (buttons[2]) buttons[2].onclick = function () { var bag=document.querySelector('.li-bag-fab'); if(bag)bag.click(); };
    var count = buttons[2] && buttons[2].querySelector('span'); if (count) count.textContent = document.querySelectorAll('.li-bag-fab span').length ? document.querySelector('.li-bag-fab span').textContent : '0';
  }
  if (mobileBar && mobileBar.querySelector('button')) mobileBar.querySelector('button').addEventListener('click', openMobileFilters);
  apply();
  syncCompare();
})();
